"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _attributeSubSection = _interopRequireDefault(require("../attributeSubSection"));

var _attributeOptions = _interopRequireDefault(require("../attributeOptions"));

var _selectors = require("../../../../../../redux/attributes/selectors");

var _customField = _interopRequireDefault(require("../../../../../_common/formik/customField"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AttributeSection = function AttributeSection(_ref) {
  var attributeId = _ref.attributeId,
      value = _ref.value,
      onChange = _ref.onChange,
      setFieldValue = _ref.setFieldValue,
      _ref$showLabel = _ref.showLabel,
      showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel;
  var attribute = (0, _selectors.useAttributeSelector)(attributeId);
  var options = attribute.options,
      groups = attribute.groups,
      type = attribute.type,
      name = attribute.name,
      description = attribute.description,
      sortOptions = attribute.sortOptions;

  var onSelectAll = function onSelectAll() {
    setFieldValue("attributes.".concat(attributeId), _objectSpread(_objectSpread({}, value), {}, {
      choice: Object.keys(options)
    }));
  };

  var onUnselectAll = function onUnselectAll() {
    setFieldValue("attributes.".concat(attributeId), _objectSpread(_objectSpread({}, value), {}, {
      choice: []
    }));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-attribute-section mb-8"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-section-header flex"
  }, showLabel && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex center font-lato text-lightBlue"
  }, name), type === "many" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ml-5 mr-5"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    color: "primary",
    onClick: onSelectAll
  }, "Select All")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    color: "primary",
    onClick: onUnselectAll
  }, "Unselect All")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-attribute-options-container"
  }, groups ? Object.keys(groups).map(function (groupKey, index) {
    return /*#__PURE__*/_react.default.createElement(_customField.default, {
      CustomComponent: _attributeSubSection.default,
      name: "attributes.".concat(groupKey),
      key: "attribute-subsection-".concat(groupKey),
      parentId: attributeId,
      attribute: groups[groupKey],
      attributeId: groupKey,
      errorField: "choice",
      setFieldValue: setFieldValue
    });
  }) : /*#__PURE__*/_react.default.createElement(_attributeOptions.default, {
    attributeName: name,
    value: value,
    onChange: onChange,
    attributeId: attributeId,
    type: type,
    options: options,
    sortOptions: sortOptions,
    setFieldValue: setFieldValue
  })), description && /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-attribute-description"
  }, description));
};

var _default = AttributeSection;
exports.default = _default;